import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TS_EditableContent } from '@nu-art/thunderstorm-frontend';
import { __stringify, tsValidateResult } from '@nu-art/ts-common';
import { TS_TextAreaV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_TextArea/index';
import './Editor_JsonToObject.scss';
export class Editor_JsonToObject extends TS_EditableContent {
    deriveStateFromProps(nextProps, _state) {
        const state = super.deriveStateFromProps(nextProps, _state);
        state.isFreeTextMode = nextProps.isFreeTextMode;
        const value = nextProps.editable.item ? __stringify(nextProps.editable.item, true) : '';
        state.value = value;
        state.isValid = this.validateItem(value).isValid;
        return state;
    }
    render() {
        const { isFreeTextMode, value, editable, isValid } = this.state;
        return _jsxs(_Fragment, { children: [!isFreeTextMode && this.props.renderer(editable), isFreeTextMode && _jsx(TS_TextAreaV2, { className: 'ts-json-to-object', resizeWithText: true, "data-valid": isValid, type: "text", value: value, onChange: async (value) => {
                        const { isValid } = this.validateItem(value);
                        return this.setState({ isValid });
                    }, onBlur: async (value) => {
                        const { isValid, item } = this.validateItem(value);
                        if (!isValid)
                            return this.setState({ isValid, value });
                        await editable.updateObj(item);
                    } })] });
    }
    validateItem(value) {
        let isValid;
        let item = {};
        try {
            item = JSON.parse(value);
            isValid = tsValidateResult(item, this.props.validator) === undefined;
        }
        catch (e) {
            isValid = false;
        }
        return { isValid, item };
    }
}
//# sourceMappingURL=Editor_JsonToObject.js.map